<template>
  <div class="flex flex-between step-item">
    <div>
      <p class="step_campaign--channel">{{ campaign.channelLabel }}</p>
      <p class="step_campaign--label">{{ campaign.label }}</p>
    </div>

    <button-icon @click="deleteCampaign" icon="delete"/>
  </div>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "StepItemCampaign",
  props: {
    campaign: {
      type: Object,
      required: true,
    },
  },
  methods: {
    deleteCampaign() {
      this.$store.commit('onboarding/deleteCampaign', this.campaign);
    },
  },
})
</script>

<style scoped lang="scss">
@import "../../../styles/variables/variables";

.step-item {
  max-width: 440px;
  padding: 8px;

  &:nth-of-type(even) {
    background-color: $background;
  }
}

.step_campaign {
  &--channel {
    margin-bottom: 4px;
    font-size: 0.75rem;
  }
}
</style>
